/**
 * Module dependencies.
 */

import { JSX, ReactNode } from 'react';
import type { LinkProps } from 'next/link';
import { Wrapper } from './link.style';

/**
 * `Props` type.
 */

type Props = LinkProps & {
  children: ReactNode;
  className?: string;
  ghost?: boolean;
  style?: JSX.IntrinsicElements['a']['style'];
  target?: string;
};

/**
 * Export `Link` component.
 */

export function Link(props: Props): JSX.Element {
  return <Wrapper {...props} />;
}
